import { call, put, takeLatest } from "redux-saga/effects";
import { httpGetQuestion } from "../../../services/questions";
import {
  fetchQuestionStart,
  fetchQuestionSuccess,
  fetchQuestionFailure,
} from "../reducer";
import { networkErrorHandler } from "../../../utils/errorHandlers";

function* getQuestion({ payload }) {
  const { id } = payload;
  const response = yield call(httpGetQuestion, id);
  const { success, raw, message } = response;

  if (success) {
    yield put(fetchQuestionSuccess(raw));
  } else {
    yield put(fetchQuestionFailure(message || raw?.error));
    networkErrorHandler(response?.statusCode, message || raw?.error);
  }
}

export default function* onGetQuestion() {
  yield takeLatest(fetchQuestionStart.type, getQuestion);
}
